module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_pp1_8019.d0a1e334.png";